<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="sampleSetCode"
      cell-class-name="align-top"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkboxConfig="{
        reserve: true,
        highlight: false,
      }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:displayImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          style="width: 100px; height: 66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:displaySampleName="{ row }">
        <TableLabel :value="row.sampleSetName" />
        <TableLabel :value="row.sampleSetNameEn" />
        <TableLabel label="No" :value="row.sampleSetNo" />
      </template>
      <template v-slot:sampleSetStatus="{ row }">
        <el-tag
          size="mini"
          :type="
            row.sampleSetStatus === 'S'
              ? 'success'
              : row.sampleSetStatus === 'N'
              ? 'danger'
              : ''
          "
        >
          {{ row.v_sampleSetStatus || 'New' }}
        </el-tag>
      </template>
      <template v-slot:scmName="{ row }">
        <TableLabel :value="row.scmName" />
        <TableLabel :value="row.scmProductNo" />
      </template>
      <template v-slot:costPrice="{ row }">
        <div>
          <span class="mr-1">{{ row.costPrice || '0' }}</span>
          <span>{{ row.v_costCurrency }}</span>
        </div>
      </template>
      <template v-slot:quotedMethod="{ row }">
        <div>
          <span class="mr-1">{{ row.quotedPrice || '0' }}</span>
          <span>{{ row.v_quotedCurrency }}</span>
        </div>
        <TableLabel :value="row.v_quotedMethod" />
      </template>
      <template v-slot:displaySalesPrice="{ row }">
        <div>
          <span v-if="row.v_salesType" class="mr-1">{{ `${row.v_salesType}：` }}</span>
          <span class="mr-1">{{ row.salesPrice || '0' }}</span>
          <span>{{ row.v_salesCurrency || '' }}</span>
        </div>
      </template>
      <template v-slot:custName="{ row }">
        <TableLabel :value="row.custName" />
        <TableLabel :value="row.customerProductNo" />
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-1">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import TableLabel from './label.vue'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: { TableLabel },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { sampleSetCode, sampleSetNo } = data
      switch (menuType) {
        case 'detail':
        case 'edit':
        case 'audit':
        case 'change':
          this.$emit('openEditPage', {
            pageType: menuType,
            params: { sampleSetCode },
            query: { sampleSetNo },
          })
          break
        case 'delete':
          this.del(data)
          break
        case 'copy':
          this.copy(data)
          break
        case 'reject':
          this.reject(data)
          break
      }
    },
    async del({ sampleSetCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_delete_setInfo') || '是否要删除该套件？套件下如果存在子件会一并删除！',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)

      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .sampleSetInfoDelApi({ sampleSetCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    async copy({ sampleSetCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_copy') || '是否要复制该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)

      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .sampleSetInfoCopyApi({ sampleSetCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_tips_copy_error') ||'复制失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.btn_sure_copy_succeeded') ||'复制成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    async reject({ sampleSetCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_reject_setInfo') || '是否要驳回该套件？套件下如果存在子件会一并驳回！',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)

      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .sampleSetInfoRejectApi({ sampleSetCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_reject_failed') || '驳回失败！')
        return
      }
      this.$message({
        message: this.$l('tips_reject_success') || '驳回成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    exportData() {
      return this.getCheckData()
    },
    getCheckData() {
      const data = this.$refs.table
        .getCheckboxRecords()
        .concat(this.$refs.table.getCheckboxReserveRecords())
      if (data.length < 1) {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_select_data') || '请选择数据!!',
          type: 'warning',
        })
        return
      }
      return {
        sampleSetCodeList: data.map((item) => item.sampleSetCode),
      }
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkboxChange', records.concat(reserves))
    },
    removeCheckBox() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkboxChange', [])
    },
  },
}
</script>
